import http from '../http'
import { Res } from '../type'

import { MyLearningTodolist } from '../Models/MyLearningTodolist'
import { MyLearningTask, MyLearningTaskParams } from '../Models/MyLearningTask'

// 我的待办/学习任务-我的待办
export const getMyLearningTodolist = (): Res<MyLearningTodolist> => {
  return http({
    url: '/sands-lms/api/v1/learning/todo-list',
    method: 'post',
    data: {
      pageNum: 1,
      pageSize: 20
    }
  })
}

// 我的待办/学习任务-学习任务
export const getMyLearningTask = (
  params: MyLearningTaskParams
): Res<MyLearningTask> => {
  return http({
    url: '/sands-lms/api/v1/learning/tasks',
    method: 'post',
    data: params,
    loadingShow: '0',
    toastShow: '0'
  })
}
